<template>
    <div style="display: flex;">
        <div class="ce-nav" style="box-shadow: 0px 2px 8px 0px rgba(195,219,255,0.25);margin-right: 16px;padding-bottom: 20px;">
            <!-- :class="{ 'exper-2':this.$route.fullPath !== '/personal/index', 'exper-3':this.$route.fullPath !== '/personal/infomation',''}" -->
            <!--  -->
            <div class="flex-1">
                <img src="../../assets/myself/grzx.png" alt="">
                <p>个人中心</p>
            </div>
            <el-tabs class="etab-1" v-model="activeName" tab-position="left" @tab-click="handleClick">
                <el-tab-pane label="个人首页" name="/personal/index"></el-tab-pane>
                <el-tab-pane label="我的信息" name="/personal/infomation"></el-tab-pane>
            </el-tabs>
            <div class="flex-1">
                <img src="../../assets/myself/wdfw.png" alt="">
                <p>我的服务</p>
            </div>
            <el-tabs v-model="activeName" tab-position="left" @tab-click="handleClick1" :before-leave="beforeLeave">
                <el-tab-pane label="我的专家" name="/personal/unlockedExperts"></el-tab-pane>
                <el-tab-pane label="直播预约" name="/allcontent"></el-tab-pane>
                <el-tab-pane label="收藏专家" name="/personal/collect/index"></el-tab-pane>
                <el-tab-pane label="发票申请" name="/personal/service/invoice/index"></el-tab-pane>
                <el-tab-pane label="证书查询" name="/personal/service/certificate/index"></el-tab-pane>
                <el-tab-pane label="联系客服" name="/personal/service/customer"></el-tab-pane>
                <el-tab-pane label="用户协议" name="/personal/service/userAgreement"></el-tab-pane>
                <el-tab-pane label="隐私协议" name="/personal/service/privacyAgreement"></el-tab-pane>
            </el-tabs>
            <div class="flex-1">
                <img src="../../assets/myself/wdhd.png" alt="">
                <p>我的活动</p>
            </div>
            <el-tabs v-model="activeName" tab-position="left" @tab-click="handleClick2">
                <el-tab-pane label="待参加" name="1000"></el-tab-pane>
                <el-tab-pane label="进行中" name="2000"></el-tab-pane>
                <el-tab-pane label="已结束" name="3000"></el-tab-pane>
            </el-tabs>
            <!--    <div>
        </div> -->

        </div>
        <router-view></router-view>
    </div>
</template>

<script>
    import Breadcrumb from '@/views/Breadcrumb.vue';
    export default {
        components: {
            Breadcrumb
        },
        data() {
            return {
                activeName: '',
            }
        },
        watch: {
        
            '$store.state.activity.activeTab'(newVal,oldVal){
                //对数据执行操作
                if (this.$route.fullPath.indexOf("/personal/activity/index") != -1) {
                    console.log(newVal,'newVal')
                    if (newVal == 1) {
                        this.activeName='2000';
                        console.log(this.activeName,'this.activeName')
                    }else if(newVal == 2){
                        this.activeName='3000';
                        console.log(this.activeName,'this.activeName')
                    } else {
                        this.activeName='1000';
                        console.log(this.activeName,'this.activeName')
                    }
                }
            }
        },
        computed: {

        },
        methods: {
            handleClick1(tab, event) {
                // if (tab.label == "直播预约") {
                //     window.open('http://baidu.com')
                // }
                this.$router.push(this.activeName)
                this.activeName = this.$route.path;
            },
            handleClick2(tab, event) {
                // this.$router.push({
                //     path: "/personal/activity/index",
                //     query: {
                //         tab: tab.name
                //     }
                // })
                // this.$router.push(this.activeName)
                let ids = tab.index;
                console.log(tab.index,'tab.index')
                if (ids == 1) {
                    this.activeName='2000';
                    this.$store.commit('saveActiveTab',ids)
                }else if(ids == 2){
                    this.activeName='3000';
                    this.$store.commit('saveActiveTab',ids)
                } else {
                    this.activeName='1000';
                    this.$store.commit('saveActiveTab',ids)
                }
                
                this.$router.push({
                    path: "/personal/activity/index",
                })
                // '/personal/activity/index'
            },
			beforeLeave(tab) {
				if (tab == '/allcontent') {
					window.open('https://applcqlstrc4234.h5.xiaoeknow.com');
					return false;
				}
			},
            handleClick(tab, event) {
                this.$router.push(this.activeName)
                this.activeName = this.$route.path;
            },
            changeColor() {

            }
        },
        created() {
            this.handleClick();
            this.handleClick1();
            // this.handleClick2();
            if (this.$route.fullPath.indexOf("/personal/activity/index") != -1) {
                var tab={
                    index:this.$store.state.activity.activeTab
                }
                this.handleClick2(tab);
            }
        },
        mounted() {

        }
    }
</script>

<style scoped>
    /deep/.ce-nav .el-tabs__item.is-left {
        font-size: 17px;
        font-weight: normal;
        color: #222222;
        /* line-height: 20px; */
        padding-right: 15%;
        text-align: center;
        /* border: 1px solid; */
    }

    /* .el-tabs--left .el-tabs__item.is-left */
    /deep/.ce-nav  .el-tabs--left .el-tabs__header.is-left {
        /* border: 1px solid; */
        float: none;
        margin-right: 0;
        /* color: #3377FF!important; */
    }

    /deep/.ce-nav  .etab-1 .el-tabs__item .is-left .is-active {
        /*  color: #3377FF!important;
        background-color: #F0F5FF!important;
        border: 1px solid; */
    }

    /deep/.ce-nav .etab-1 .el-tabs__item .is-left .is-active {
        /* border: 1px solid; */
    }

    /deep/ .ce-nav .el-tabs__item.is-active {
        color: #3377FF !important;
        ;
        background-color: #F0F5FF !important;
    }

    /deep/.ce-nav .el-tabs__nav {
        width: 99%;
    }

    /deep/.ce-nav .el-tabs__nav-scroll {
        padding: 0;
    }

    /deep/.ce-nav .el-tabs--left .el-tabs__nav-wrap.is-left::after {
        width: 0px;
    }

    /deep/.ce-nav .el-tabs--left .el-tabs__active-bar.is-left {
        width: 0px;
    }

    /deep/.ce-nav .el-tabs__item {
        width: auto;
    }

    .flex-1 {
        display: flex;
        align-items: center;
        padding: 16px 66px 16px 24px;
    }

    .flex-1 img {
        width: 18px;
        height: 18px;
        padding-right: 12px;
    }

    .flex-1 p {
        color: #222222;
        font-size: 17px;
        line-height: 20px;
        /* overflow:hidden; */
        white-space: nowrap;
        /* text-overflow: ellipsis; */
    }

    .exper {
        display: flex;
        /* margin-top: 16px; */
        box-shadow: 0px 2px 8px 0px rgba(195, 219, 255, 0.25);
        border-radius: 8px 8px 8px 8px;
        text-align: center;
        margin-right: 16px;
        /* width: 36.9%; */
    }

    .exper-1 {
        display: flex;
        width: 100%;
        /*     width: 100%;÷
       display: flex;
       margin-top: 16px; */
        /* border: 1px solid; */
    }

    .exper-2 {
        box-shadow: 0px 2px 8px 0px rgba(195, 219, 255, 0.25);
        /* border-radius: 8px 8px 8px 8px;text-align: center;margin-right: 16px; */
        /* width: 36.9%; */
    }

    .exper-3 {
        /* width: 100%; */
        box-shadow: 0px 2px 8px 0px rgba(195, 219, 255, 0.25);
        border-radius: 8px 8px 8px 8px;
        text-align: center;
        margin-right: 16px;
    }
</style>
